export let RESPONSE_STATUS = {
	OK: "ok",
	ERROR: "error",
}

